import { render, staticRenderFns } from "./WorksMatchingDetail.vue?vue&type=template&id=1bfa5fc0&scoped=true&"
import script from "./WorksMatchingDetail.vue?vue&type=script&lang=js&"
export * from "./WorksMatchingDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorksMatchingDetail.vue?vue&type=style&index=0&id=1bfa5fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa5fc0",
  null
  
)

export default component.exports